export default __webpack_public_path__ + "static/media/img-5.6594a4d3.jpg";